import React from 'react'
import { marked } from 'marked'
import { strapiUrl } from '../../utils/variables'

/**
 * RichText component for rendering markdown content
 * @param {Object} props - Component props
 * @param {Object} props.data - Data containing markdown body
 * @returns {JSX.Element}
 */
const RichText = ({ data }) => {
    if (!data || (!data.body && !data.content)) {
        return null
    }

    let body = data.content || data.body

    // ✅ Remove FIRST markdown H1 (page title)
    body = body.replace(/^#\s+.+\n+/i, '')

    // Replace relative Strapi URLs with absolute URLs
    body = body.replaceAll('(/uploads', `(${strapiUrl}/uploads`)

    marked.setOptions({
        mangle: false,
        headerIds: true,
        breaks: true
    })

    return (
        <div
            className="blog-content rich-text"
            dangerouslySetInnerHTML={{ __html: marked(body) }}
        />
    )
}

export default RichText
